import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TableService {


  constructor(private http: HttpClient) { }

  fetchTableData(apiUrl) {

    return this.http.get(apiUrl);

  }

}